import { render } from "./SettingUnsubscribleUser.vue?vue&type=template&id=8c607694"
import script from "./SettingUnsubscribleUser.vue?vue&type=script&lang=js"
export * from "./SettingUnsubscribleUser.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__